import React from 'react'

import { useTranslation } from 'react-i18next'
import { FieldProps } from '../../../../../../../@types/types'
import { OtherFacilitiesScreenValidationResult } from '../../../../../../../@types/validation-types'
import { TextInput } from '../../../../../../common/inputs/textInput/TextInput'
import { getDefaultClasses } from '../../../../../../../utils/style-utils'

export enum UsableAreaVariants {
  DEFAULT = 'default',
  OTHER = 'other',
}

const usableAreaSetup = {
  default: {
    maxLength: 13, // 99.999.999,99
    label: 'usableArea',
  },
  other: {
    maxLength: 5, // 99.99
    label: 'usableAreaOther',
  },
}

export type UsableAreaFieldProps = {
  variant?: UsableAreaVariants
}

const UsableAreaField: React.FC<FieldProps<OtherFacilitiesScreenValidationResult> & UsableAreaFieldProps> = ({
  screenName,
  insertionData,
  validationMessages,
  variant = UsableAreaVariants.DEFAULT,
  wrapperClassName = getDefaultClasses('left'),
  onChange,
}) => {
  const { t } = useTranslation()

  return (
    <div className={wrapperClassName}>
      <TextInput
        id='usable-area'
        propertyName='usableArea'
        placeholder=''
        label={<span>{t(`wizard.screen.otherFacilities.${usableAreaSetup[variant].label}`, 'Usable Area')}</span>}
        value={insertionData.usableArea}
        maxLength={usableAreaSetup[variant].maxLength}
        type='text'
        affixRight='unit'
        unitRight='sqm'
        errors={validationMessages?.usableArea ?? []}
        doOnFieldChange={(property, value) => onChange({ screen: screenName, property }, value)}
      />
    </div>
  )
}

export default UsableAreaField
